import { type PanelDescriptor } from '@/screens/types';

const BOOTSTRAP_PREFIX = 'trms_workbench_detached_panel:';

export function resolveDetachSessionId(
  workbenchSessionId: string | null,
  userId: string | null | undefined,
): string {
  return workbenchSessionId ?? userId ?? 'workbench-local';
}

function bootstrapKey(panelId: string): string {
  return `${BOOTSTRAP_PREFIX}${panelId}`;
}

export function writeDetachedBootstrap(panel: PanelDescriptor, theme: string): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(bootstrapKey(panel.panelId), JSON.stringify({ panel, theme }));
}

export function readDetachedBootstrap(
  panelId: string,
): { panel: PanelDescriptor; theme: string } | null {
  if (typeof window === 'undefined') return null;
  const raw = window.localStorage.getItem(bootstrapKey(panelId));
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as unknown;
    if (parsed !== null && typeof parsed === 'object' && 'panel' in parsed && 'theme' in parsed) {
      const typed = parsed as { panel: PanelDescriptor; theme: string };
      return typed;
    }
    // Legacy format: raw PanelDescriptor without theme wrapper
    return { panel: parsed as PanelDescriptor, theme: 'system' };
  } catch {
    return null;
  }
}

export function clearDetachedBootstrap(panelId: string): void {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(bootstrapKey(panelId));
}
